
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topsellernew",
      function () {
        return require("private-next-pages/topsellernew/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topsellernew"])
      });
    }
  